import React, { PureComponent, useState } from 'react';
import { Link } from 'react-router-dom';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';

import { ListingTypes } from 'data/search';
import { getGoogleImageUrl } from 'data/property';
import numberToPrice from 'utils/currency/numberToPrice';

import CustomTabs from 'components/CustomTabs';
import AnalysisButton from 'app/components/AnalysisButton';
import Image from 'components/base/Image';
import Button, { ButtonLink } from 'components/base/Button';
import Label from 'components/Label';
import SVG from 'components/base/SVG';
import Table from 'components/base/Table';
import css from './style.scss';
import numberFormat from 'utils/number/format';
import ColumnsRenderers from '../Columns';
import { getAerialImageUrl } from 'utils/brand';
import BedIcon from '../../../assets/images/Bed.svg';
import Bath from '../../../assets/images/Bath.svg';
import LotSize from '../../../assets/images/LotSize.svg';
import SqFt from '../../../assets/images/SqFt.svg';
import Home from '../../../assets/images/home-white.svg';
import Bookmark from '../../../assets/images/SaveIcon-NotSaved.svg';
import Bookmarkwhite from '../../../assets/images/bookmark-white.svg';
import Gallery from '../../../assets/images/gallery.svg';
import { openGallery } from '../../Property/Gallery/GalleryPortalRenderer';
import ImageDefault from '../../../assets/images/Img.svg';
import ImageHover from '../../../assets/images/HoverImg.svg';
import Leftarrow from '../../../assets/images/account-page/left-arrow.svg';
import LeftarrowHover from '../../../assets/images/account-page/angle-left-regular.svg';

// import LeftarrowHover from '../../../assets/images/pagination-images/left-vector.svg';
//PropertyTypeIcons
import ResidentialIcon from '../../../assets/images/ResidentialIcon.svg';
import CommercialIcon from '../../../assets/images/CommercialIcon.svg';
import OfficeIcon from '../../../assets/images/OfficeIcon.svg';
import IndustrialIcon from '../../../assets/images/IndustrialIcon.svg';
import AgricultureIcon from '../../../assets/images/AgricultureIcon.svg';
import RecreationalIcon from '../../../assets/images/RecreationalIcon.svg';
import TransportationIcon from '../../../assets/images/TransportationIcon.svg';
import ExemptIcon from '../../../assets/images/ExemptIcon.svg';
import VacantLandIcon from '../../../assets/images/VacantLandIcon.svg';

import NotSave from '../../../assets/images/SaveIcon-NotSaved.svg'
import SaveIcon from '../../../assets/images/SaveIcon-Saved.svg'
import SaveHoverIcon from '../../../assets/images/SaveIcon-Hover.svg'
import RecentProperty from '../../components/RecentProperty';
import ListModal from '../../components/RecentListModal/ListModal';

const RightFields = [
  { field: 'estimatedValue', label: 'Estimated Value', formatter: numberToPrice, defaultValue: '-' },
  { field: 'onMarket', label: 'Status', formatter: v => (v ? 'On Market' : 'Off Market') },
  { field: 'distressed', label: 'Distressed', formatter: v => (v ? 'Yes' : 'No') },
  { field: 'involuntaryLienAmount', label: 'Liens', formatter: numberToPrice, defaultValue: 0 },
  { field: 'ownership', label: 'Owner', highlight: true },
  { field: 'occupancy', label: 'Owner', highlight: true },
];

const TabFields = [
  { field: 'neighbors', label: 'Neighbors', type: ListingTypes.Neighbor, fields: ['COUNTER', 'ADDRESS', 'BEDROOMS', 'BATHROOMS', 'ESTIMATE_VALUE', 'SALE_PRICE', 'SALE_DATE'] },
  { field: 'nearbyMlsListings', label: 'MLS', type: ListingTypes.M, fields: ['COUNTER', 'ADDRESS', 'BEDROOMS', 'BATHROOMS', 'LISTING_PRICE', 'LISTING_DATE', 'STATUS'] },
  { field: 'nearbyPreForeclosures', label: 'Pre Foreclosures', type: ListingTypes.P, fields: ['COUNTER', 'ADDRESS', 'BEDROOMS', 'BATHROOMS', 'DOCUMENT_TYPE', 'LISTING_AMOUNT', 'UPDATE_DATE'] },
  { field: 'nearbyForeclosures', label: 'Bank Owned', type: ListingTypes.F, fields: ['COUNTER', 'ADDRESS', 'BEDROOMS', 'BATHROOMS', 'DOCUMENT_TYPE', 'LISTING_AMOUNT', 'UPDATE_DATE'] },
];

const CircularProgress = ({ percentage, size = 28, strokeWidth = 4, color = '#128292', backgroundColor = '#DFE1E4' }) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - Math.max(0, Math.min(percentage, 100)) / 100 * circumference;

  return (
    <svg width={size} height={size}>
      <circle
        stroke={backgroundColor}
        fill="none"
        strokeWidth={strokeWidth}
        cx={size / 2}
        cy={size / 2}
        r={radius}
      />
      <circle
        stroke={color}
        fill="none"
        strokeWidth={strokeWidth}
        cx={size / 2}
        cy={size / 2}
        r={radius}
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        strokeLinecap="round"
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
      />
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        dominantBaseline="middle"
        alignmentBaseline="central"
        fontSize="11"
        fill={color}
        fontWeight="bold"
      >
        {`${Math.max(0, Math.min(percentage, 100))}`}
      </text>
    </svg>
  );
};

class PropertyView extends PureComponent {
  static defaultProps = { onBack: () => { } };
  constructor(props) {
    super(props);

    this.handleSelect = this.handleSelect.bind(this);
    this.handleSave = this.handleSave.bind(this);

    this.state = {
      savedPropertyId: null,
      isClicked: false,
      isSaveHovered: false,
      showTitle: false,
      showAddressTooltip: false,
      isIconHovered: false,
      isModalOpen: false,
      modalPropertyId: null,
      isIconHovered: false
    };
  }

  handleMouseEnterAddress = (e) => {
    this.setState({ showAddressTooltip: e.target.offsetWidth < e.target.scrollWidth });
  };

  handleSave() {
    const { onSaveProperty, result } = this.props;
    const subject = result.get('property');
    const id = subject?.get('id');
    onSaveProperty(id);
    this.setState({ savedPropertyId: id });
  }

  handleSaveMouseEnter = () => {
    this.setState({ isSaveHovered: true });
  };

  handleSaveMouseLeave = () => {
    this.setState({ isSaveHovered: false });
  };

  handleSelect(index) {
    this.props.setActiveContext(TabFields[index].type);
  }

  handleSelect(index) {
    this.props.setActiveContext(TabFields[index].type);
  }

  render() {
    const { result, sort, onSort, onClick, activeContext, loading, activeMarker, selectProperty, } = this.props;
    const subject = result?.get('property');
    const id = subject?.get('id');
    const bedrooms = subject?.get('bedrooms');
    const bathrooms = subject?.get('bathrooms');
    const squareFeet = subject?.get('squareFeet');
    const lotSquareFeet = subject?.get('lotSquareFeet');
    const estimatedValue = subject?.get('estimatedValue');
    const equityPercentage = subject?.get('equityPercentage')
    const estimatedValueGraph = subject?.get?.('estimatedValueGraph');
    const { showAddressTooltip } = this.state;
    const savedPropertyCount = subject?.get('savedPropertyCount');
    const groupName = subject?.getIn(['group', 'name']) || '';
    const groupId = subject?.getIn(['group', 'id']);
    let oneYearPoint;

    if (estimatedValueGraph?.get) {
      const series = estimatedValueGraph.get('series');
      const firstSeries = series?.get(0);
      const points = firstSeries?.get('points')?.toJS();
      oneYearPoint = points?.find(p => p.label === '1yr')?.value;
    } else {
      const series = estimatedValueGraph?.series;
      const points = series?.[0]?.points;
      oneYearPoint = points?.find(p => p.label === '1yr')?.value;
    }

    const C = oneYearPoint ? ((estimatedValue - oneYearPoint) / oneYearPoint) * 100 : 0;
    const roundedC = Math.round(C);
    const formattedC = oneYearPoint ? `${roundedC > 0 ? '+' : ''}${roundedC}%` : '-';

    const selectPropertyId = selectProperty.get('id');
    const propertyDetailsSavedPropertyId = selectProperty.get('savedPropertyId');
    const savedPropertyId = this.state.savedPropertyId || result.getIn(['property', 'savedPropertyId']);
    const saved = !!savedPropertyId;
    const propertyType = subject?.get('propertyType');
    const landUse = subject?.get('landUse');
    const propertyClass = subject?.get('propertyClass');
    const linkToDetails = `/search/${id}`;
    const results = activeContext?.get('displayResults');


    const street = subject?.getIn(['address', 'streetAddress']) || '';
    const city = subject?.getIn(['address', 'cityName']) || '';
    const state = subject?.getIn(['address', 'stateCode']) || '';
    const zip = subject?.getIn(['address', 'zip']) || '';

    const isValid = (val) =>
      typeof val === 'string' &&
      val.trim() !== '' &&
      !val.includes('0000') &&
      !val.includes('00000') &&
      !val.includes('<No Street Address>') &&
      val.toLowerCase() !== 'undefined';
    // Build the clean address parts
    let address = '';

    if (isValid(street)) address += street;

    if (isValid(city)) {
      if (address) address += ' ';
      address += city;
    }

    const stateZip = [state, zip].filter(isValid).join(' ');
    if (stateZip) {
      if (address) address += ', ';
      address += stateZip;
    }

    const fullAddress = isValid(state) && address.trim() == state ? 'Address Unavailable' : address || 'Address Unavailable';

    const Tiles = [
      { field: 'estimatedEquity', label: 'EST. EQUITY' },
      { field: '1YrChange', label: '1 YR. VAL. CHANGE', customValue: formattedC },
      { field: 'compSaleAmount', label: 'AVG.COMPS' },
      { field: 'rentAmount', label: 'EST.RENT' },
    ];

    const filteredTiles = Tiles.filter(f => {
      if (f.customValue !== undefined) {
        return f.customValue && f.customValue !== '-' && f.customValue !== 'N/A';
      }

      const val = subject?.get(f.field);
      return val !== null && val !== undefined && val !== '' && val !== 'N/A' && val !== 0;
    });

    const hasEstimatedEquity = subject?.get('estimatedEquity') !== null &&
      subject?.get('estimatedEquity') !== undefined &&
      subject?.get('estimatedEquity') !== '' &&
      subject?.get('estimatedEquity') !== 'N/A';

    const showProgress = hasEstimatedEquity;

    let imageUrl = subject?.get('imageUrl');

    const isFallbackImage =
      imageUrl === '' ||
      imageUrl?.includes('coming_soon') ||
      imageUrl?.includes('photo_coming_soon') ||
      imageUrl?.includes('house-img-not-available') ||
      imageUrl?.includes("placeholder")

    const updatedImageUrl = (() => {
      if (!imageUrl) return imageUrl;
      try {
        const url = new URL(imageUrl);
        const hostParts = url.hostname.split('.');

        if (
          hostParts.length === 4 &&
          hostParts[0] === 'images' &&
          hostParts[2] === 'propstream' &&
          hostParts[3] === 'com'
        ) {
          hostParts.splice(1, 1);
          url.hostname = hostParts.join('.');
        }

        return url.toString();
      } catch {
        return imageUrl;
      }
    })();

    const imageUrls = isFallbackImage
      ? '../../../assets/images/nophoto-searchtile.jpg'
      : updatedImageUrl;

    const iconMap = {
      RESIDENTIAL: ResidentialIcon,
      COMMERCIAL: CommercialIcon,
      OFFICE: OfficeIcon,
      INDUSTRIAL: IndustrialIcon,
      AGRICULTIRAL: AgricultureIcon,
      RECREATIONAL: RecreationalIcon,
      TRANSPORTATION: TransportationIcon,
      EXEMPT: ExemptIcon,
      VACANT: VacantLandIcon,
    };

    const handleGalleryClick = () => {
      openGallery({ id: id });
    };

    const getIcon = () => {
      if (saved) return SaveIcon;
      return this.state.isSaveHovered ? SaveHoverIcon : NotSave;
    };

    const handleAdditionalClick = (id, e) => {
      // e?.stopPropagation?.();
      // this.setState({
      //   isModalOpen: true,
      //   modalPropertyId: id,
      // });
    };

    return (
      <div className={css.property}>
        <div className={css.propertyCard}>
          <div className={css.subject}>
            <img className={css.bg} src={imageUrls} alt="" />

            <div className={css.buttonContainer} style={{ justifyContent: this.props.backBtnFlag ? 'space-between' : 'flex-end' }}>
              {this.props.backBtnFlag &&
                <div className={`${css.backIconButton} ${this.state.isClicked ? css.clicked : ''}`}
                  onClick={this.props.onBack}
                  onMouseDown={() => this.setState({ isClicked: true })}
                  onMouseUp={() => this.setState({ isClicked: false })}
                  onMouseLeave={() => this.setState({ isClicked: false })}>
                  <img src={Leftarrow} alt="Default" className={`${css.imgBackDefaultIcon}`} />
                  <img src={LeftarrowHover} alt="Hover" className={`${css.imgBackHoverIcon}`} />
                  <text>
                    Back
                  </text>
                </div>
              }
              {/* right-hand cluster */}
              <div className={css.rightButtons}>
                <ButtonLink to={linkToDetails} className={css.textButton}>Details</ButtonLink>
                {!isFallbackImage && (
                  <button
                    className={`${css.imageIconButton} ${this.state.isClicked ? css.clicked : ''}`}
                    onClick={handleGalleryClick}
                    onMouseDown={() => this.setState({ isClicked: true })}
                    onMouseUp={() => this.setState({ isClicked: false })}
                    onMouseLeave={() => this.setState({ isClicked: false })}
                  >
                    <img src={ImageDefault} alt="Default" className={`${css.imageIcon} ${css.imgDefaultIcon}`} />
                    <img src={ImageHover} alt="Hover" className={`${css.imageIcon} ${css.imgHoverIcon}`} />
                  </button>
                )}
              </div>
            </div>
          </div>

          <div className={css.container}>
            <div className={css.leftitem}>
              <div className={css.propertyDetails}>
                <div className={css.checkboxContainer}>
                  <div className={css.topIcons}>
                    <div className={css.headResult}>
                      <div className={css.tagParent}>
                        <div className={`${css.tag} ${css.fadeInOut}`}
                          onMouseEnter={() => this.setState({ isIconHovered: true })}
                          onMouseLeave={() => this.setState({ isIconHovered: false })}>
                          <img
                            src={iconMap[propertyClass?.toUpperCase()] || ResidentialIcon}
                            className={css.iconProperties}
                            alt={propertyClass}
                          />
                          <span className={css.res} style={{ height: '28px', padding: '5px 0' }}>
                            {(propertyClass ? propertyClass.charAt(0).toUpperCase() + propertyClass.slice(1).toLowerCase() : '')}
                            {landUse ? ` – ${landUse}` : ''}
                          </span>
                        </div>
                      </div>
                      <div className={css.fadeChild}>
                        {saved &&
                          <RecentProperty
                            listName={groupName}
                            count={savedPropertyCount}
                            groupId={groupId}
                            isIconHovered={this.state.isIconHovered}
                            history={history}
                            redirectFlag={true}
                            disabled={false}
                            onAdditionalClick={(e) => handleAdditionalClick(id, e)}

                          />
                        }
                      </div>
                    </div>
                  </div>
                </div>

                <div className={css.mainData}>
                  <div className={css.info}>
                    <div className={css.header}>
                      <div className={css.left}>
                        <div className={css.saveIconsContainer}>
                          {subject?.get('onMarket') === true ? (
                            <div className={css.bookmark}>
                              <div className={css.value}>
                                {typeof subject?.getIn(['mlsListing', 'amount']) === 'number' && !isNaN(subject?.getIn(['mlsListing', 'amount'])) ? (
                                  <>
                                    <span title={numberToPrice(subject?.getIn(['mlsListing', 'amount']))}>
                                      {numberToPrice(subject?.getIn(['mlsListing', 'amount']))}
                                    </span>
                                    <span className={css.estvalue}> LIST PRICE </span>
                                  </>
                                ) : (
                                  'N/A'
                                )}
                              </div>
                            </div>
                          ) : (
                            !numberToPrice(subject?.get('estimatedValue', 0)) ? null : (
                              <div className={css.bookmark}>
                                <div className={css.value}>
                                  {typeof subject?.get('estimatedValue') === 'number' && !isNaN(subject?.get('estimatedValue')) ? (
                                    <>
                                      <span title={numberToPrice(subject?.getIn(['mlsListing', 'amount']))}>
                                        {numberToPrice(subject?.get('estimatedValue'))}
                                      </span>
                                      <span className={css.estvalue}> EST. VALUE </span>
                                    </>
                                  ) : (
                                    'N/A'
                                  )}
                                </div>
                              </div>
                            )
                          )}
                          <div className={css.topIcons}>
                            <div className={`${css.tag} ${css.hoverable} ${saved ? css.disabled : ''}`}
                              onMouseEnter={!saved ? this.handleSaveMouseEnter : undefined}
                              onMouseLeave={!saved ? this.handleSaveMouseLeave : undefined}
                              onClick={!saved ? () => this.handleSave() : undefined}
                            >
                              <span className={css.res}>Save</span>
                              <img
                                src={getIcon()}
                                className={css.iconProperties}
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className={css.name}
                          title={showAddressTooltip ? fullAddress : ''}
                          onMouseEnter={this.handleMouseEnterAddress}
                        >
                          <Link to={`/search/${id}`} className={css.textOnly}>{fullAddress}</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "10px" }}>
                    {[
                      { value: bedrooms, icon: BedIcon, label: "Bd." },
                      { value: bathrooms, icon: Bath, label: "Ba." },
                      { value: squareFeet, icon: SqFt, label: "SQFT" },
                      { value: lotSquareFeet, icon: LotSize, label: "LOT" }
                    ]
                      .filter(c => c.value)
                      .map((c, index, arr) => (
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px"
                          }}
                        >
                          {/* Icon + Text */}
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <img
                              src={c.icon}
                              alt={c.label}
                              style={{ width: "20px", height: "20px" }}
                            />
                            <span className={css.iconCounts}>
                              {numberFormat(c.value)}
                              {(c.label === "SQFT" || c.label === "LOT") && (
                                <span
                                  style={{
                                    color: "#66707D",
                                    fontSize: "12px",
                                    fontFamily: "Inter",
                                    fontWeight: 600,
                                    position: "relative",
                                    fontStyle: "normal",
                                    lineHeight: "12px",
                                    textTransform: "uppercase"
                                  }}
                                >
                                  {c.label}
                                </span>
                              )}
                            </span>

                          </div>

                          {/* Separator */}
                          {index !== arr.length - 1 && (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px"
                              }}
                            >
                              <div
                                style={{
                                  width: "1px",
                                  height: "20px",
                                  backgroundColor: "#DFE1E4"
                                }}
                              />
                            </div>
                          )}
                        </div>
                      ))}
                  </div>
                  <div
                    style={{ borderBottom: '1px solid #DFE1E4', width: '100%', margin: '12px 0' }}
                  />
                </div>
              </div>
              {(filteredTiles.length > 0) && (
                <div className={css.footer}>
                  {showProgress && (
                    <CircularProgress percentage={equityPercentage} color="#128292" backgroundColor="#DFE1E4" />
                  )}

                  <div className={css.fieldGroup}>
                    {filteredTiles.map((f, index) => (
                      <React.Fragment key={f.field}>
                        <div className={css.field}>
                          <div className={css.title}>{f.label}</div>
                          <div className={css.value}>
                            {f.customValue !== undefined
                              ? f.customValue
                              : numberToPrice(subject?.get(f.field), '-')}
                          </div>
                        </div>
                        {index !== filteredTiles.length - 1 && (
                          <div className={css.separator} />
                        )}
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <div className={css.dividerLine}></div>

            <div className={css.rightitem}>
              <div className={css.detailRow}>
                <div className={css.label}>Status</div>
                <div className={css.value}>{subject?.get('onMarket') ? 'On Market' : 'Off Market'}</div>
              </div>
              <div className={css.detailRow}>
                <div className={css.label}>Distressed</div>
                <div className={css.value}>{subject?.get('distressed') ? 'Yes' : 'No'}</div>
              </div>
              <div className={css.detailRow}>
                <div className={css.label}>Liens</div>
                <div className={css.value}>{subject?.get('involuntaryLienAmount') ? 'Yes' : 'No'}</div>
              </div>
              <div className={css.detailRow}>
                <div className={css.label}>Owner Type</div>
                <div className={css.value}>{subject?.get('ownership') || '-'}</div>
              </div>
              <div className={css.detailRow}>
                <div className={css.label}>Owner Status</div>
                <div className={css.value}>{subject?.get('occupancy') || '-'}</div>
              </div>
              <div className={css.detailRow}>
                <div className={css.label}>Year Built</div>
                <div className={css.value}>{subject?.get('yearBuilt') || '-'}</div>
              </div>
            </div>
          </div>
        </div>
        <CustomTabs kind="line" className={css.bottomTable}>

          <div className={css.fixedTabBar}>
            <div className={css.tabBarLeft}>Nearby</div>
            <div className={css.tabBarRight}>
              <Tabs selectedIndex={TabFields.findIndex(t => t.type === result.get('activeContext'))} onSelect={this.handleSelect}>
                <TabList>
                  {TabFields.map(t => (
                    <Tab key={t.label}>{t.label} ({result.getIn(['contexts', t.type, 'resultCount'])})</Tab>
                  ))}
                </TabList>
              </Tabs>
            </div>
          </div>

          <div className={css.scrollableTable}>
            <Tabs selectedIndex={TabFields.findIndex(t => t.type === result.get('activeContext'))} onSelect={this.handleSelect}>
              {TabFields.map(({ fields }) => (
                <TabPanel key={fields.join('-')}>
                  <div style={{ borderRadius: "10px", overflow: 'hidden' }}>
                    <Table
                      data={results}
                      sortFields={sort}
                      onColumnSort={onSort}
                      onRowClick={onClick}
                      keyField="id"
                      className="type_11"
                      isSortable
                      isHoverable
                    >
                      {fields.map(f =>
                        ColumnsRenderers[f]({ activeMarker }, <SVG icon={`iconCaret${activeContext?.get('sortAscending') ? 'Up' : 'Down'}`} />)
                      )}
                    </Table>
                  </div>

                </TabPanel>
              ))}
            </Tabs>
          </div>
        </CustomTabs>
        <ListModal
          isOpen={this.state.isModalOpen}
          onClose={() => this.setState({ isModalOpen: false, modalPropertyId: null })}
          propertyId={this.state.modalPropertyId}
          history={history}
          displayResults={subject}
          displayResults1={result}
        />
      </div>
    );
  }
}


PropertyView.propTypes = {};

export default PropertyView;